import { gql } from '@apollo/client';
import TableSettingsFragment from '../../fragments/TableSettings/TableSettings';

const UPDATE_INCOMING_ORDERS_TABLE_SETTINGS = `mutation updateTableSettings($fields: [CompanyTableSettingInput!]) {
	incomingOrders {
		updateTableSetting(fields: $fields) {
			...TableSettings
		}
	}
	${TableSettingsFragment}
}`
export default UPDATE_INCOMING_ORDERS_TABLE_SETTINGS;